<template>
	<v-card class="chart-card" elevation="2" rounded="xl">

		<div class="chart-header">
			<div class="chart-header-left">
				<div class="chart-icon-box">
					<v-icon size="18" color="white">mdi-chart-areaspline</v-icon>
				</div>
				<div>
					<p class="chart-title">Évolution des présences</p>
					<p class="chart-subtitle">{{ subtitleLabel }}</p>
				</div>
			</div>

			<div class="chart-filters">
				<button
					v-for="f in filters"
					:key="f.value"
					class="filter-btn"
					:class="{ 'filter-btn--active': period === f.value }"
					@click="period = f.value"
				>
					{{ f.label }}
				</button>
			</div>
		</div>

		<v-divider></v-divider>

		<v-card-text class="chart-body">
			<area-chart
				:data="chartUrl"
				:key="chartUrl"
				label="Présences"
				:legend="false"
				:messages="{ empty: 'Aucune donnée disponible' }"
				:colors="['#c62828']"
				:download="false"
				:prefix="''"
				height="260px"
			></area-chart>
		</v-card-text>

	</v-card>
</template>

<script>
import server from "@/config/address";
export default {
	data() {
		return {
			server,
			period: "week",
			filters: [
				{ label: "Jour", value: "day" },
				{ label: "Semaine", value: "week" },
				{ label: "Mois", value: "month" },
			],
		};
	},
	computed: {
		currentVenueId() {
			return this.$store.getters.currentVenueId;
		},
		currentVenueName() {
			return this.$store.getters.currentVenue?.name || null;
		},
		chartUrl() {
			const base = `${this.server.url}/presence/chart?period=${this.period}`;
			return this.currentVenueId ? `${base}&salle=${this.currentVenueId}` : base;
		},
		subtitleLabel() {
			const labels = {
				day: "Fréquentation du jour",
				week: "Fréquentation de la semaine",
				month: "Fréquentation du mois",
			};
			const label = labels[this.period];
			return this.currentVenueName ? `${label} — ${this.currentVenueName}` : label;
		},
	},
};
</script>

<style scoped>
.chart-card {
	font-family: Montserrat, sans-serif;
	height: 100%;
}

.chart-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 18px 20px 14px;
	gap: 12px;
	flex-wrap: wrap;
}

.chart-header-left {
	display: flex;
	align-items: center;
	gap: 14px;
}

.chart-icon-box {
	width: 38px;
	height: 38px;
	border-radius: 10px;
	background: #c62828;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.chart-title {
	font-size: 0.92rem;
	font-weight: 700;
	color: #111827;
	margin: 0 0 2px;
}

.chart-subtitle {
	font-size: 0.72rem;
	color: #9ca3af;
	margin: 0;
}

.chart-filters {
	display: flex;
	gap: 4px;
	background: #f3f4f6;
	border-radius: 10px;
	padding: 4px;
}

.filter-btn {
	padding: 5px 14px;
	border-radius: 7px;
	border: none;
	background: transparent;
	font-family: Montserrat, sans-serif;
	font-size: 0.75rem;
	font-weight: 600;
	color: #6b7280;
	cursor: pointer;
	transition: background 0.15s, color 0.15s;
}

.filter-btn:hover {
	background: #e5e7eb;
	color: #374151;
}

.filter-btn--active {
	background: #ffffff;
	color: #c62828;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.chart-body {
	padding: 16px 20px 12px;
}
</style>
